<div class="main">
    <div class="contant">
        <p>Download our Free Coaching e-Book and Begin Your Certification Now!</p>
        <button>    
            <a href="../../../assets/coaching e-book.pdf" target="_blank" class="ebook-button">
                Download Free e-Book
            </a>
        </button>

    </div>
</div>


<!-- navbar section  -->
 <!-- <app-navbar2></app-navbar2> -->
 <nav class="navbar navbar-expand-md navbar-light" id="navbar">
  <img src="../../../assets/NEXGEN Logo final.png" alt="" routerLink="/home" class="navbar-brand">

  <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <div class="nav-container">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" routerLink="/home">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/about-us">About Us</a>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" (click)="toggleDropdown(); $event.stopPropagation()" [class.active]="isNavbarOpen" role="button">
            Certification Programs
          </a>
          <ul class="dropdown-menu" [class.show]="isNavbarOpen" *ngIf="isNavbarOpen">
            <li><a class="dropdown-item" routerLink="/platinum-package">Platinum Packages</a></li>
            <li><a class="dropdown-item" routerLink="/gold-package">Gold Packages</a></li>
            <li><a class="dropdown-item" routerLink="/program-page">Program Packages</a></li>
          </ul>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/instructors">Instructors</a>
        </li>
      </ul>
    </div>
    <div class="button d-flex">
        <div class="button d-flex">
      <button id="button1" >Introduction Video</button>
      <button id="button2" routerLink="/login"><a href="">Log In</a></button>
    </div>
    </div>
  </div>
</nav>


<div class="landing-container">
.
</div>

<app-vertual></app-vertual>